import { html, type TemplateResult } from 'lit';

export interface AppHeaderProps {
  name: string;
  location: string;
  github: string;
  linkedin: string;
  email: string;
}

export function renderAppHeaderPresentation(props: AppHeaderProps): TemplateResult {
  const { name, location, github, linkedin, email } = props;

  return html`
    <header class="header-container">
      <div class="title-area">
        <h1>${name}</h1>
        <div class="meta-line">
          <span>${location}</span>
          <span>•</span>
          <a class="meta-link" href="${github}" target="_blank" rel="noopener">GitHub</a>
          <a class="meta-link" href="${linkedin}" target="_blank" rel="noopener">LinkedIn</a>
          <a class="meta-link" href="mailto:${email}">${email}</a>
        </div>
      </div>
    </header>
  `;
}
